function getCookie(name) {
  var b = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');

  return b ? b.pop() : null;
}

function deleteCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

window.getCookie = getCookie;
window.deleteCookie = deleteCookie;

